import React, { useEffect, useState } from "react";
import { Avatar } from "antd";
import { useNavigate } from "react-router-dom";
import { UserOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import defaultProfile from "../../assets/img/profile-icon.svg";
import { formatProfileMobileNumber } from "../../utils/comman";
import Button from "../../../src/components/Button/Button";

export const Updateaccountdetails = () => {
  const [userData, setUserData] = useState<any>(null);
  const navigate = useNavigate();

  const user = useSelector((state: any) => state?.Auth?.user);

  useEffect(() => {
    if (user) {
      // Handle both nested user object and direct user object
      const currentUser = user.user || user;
      setUserData(currentUser);
    }
  }, [user]);

  const handleBack = () => {
    navigate(-1);
  };

  // Get current user data for rendering
  const currentUser = userData || user?.user || user;

  return (
    <>
      <div className="profile-view-container">
        <h1 className="text-3xl font-bold text-left mb-6 text-white">
          Profile
        </h1>

        <div className="profile-container bg-[#013351] rounded-lg shadow-lg p-6 mb-6">
          <div className="flex flex-col lg:flex-row gap-6">
            {/* Profile Image Section - Left */}
            <div className="profile-image-section flex-shrink-0 text-center lg:text-left">
              <div className="mb-4">
                <h6 className="text-white-700 font-semibold text-lg mb-4">
                  Profile Image
                </h6>
              </div>
              <div className="profile-pic-container flex justify-center lg:justify-start">
                <Avatar
                  size={200}
                  src={
                    currentUser?.profilePhoto
                      ? currentUser.profilePhoto
                      : defaultProfile
                  }
                  icon={!currentUser?.profilePhoto && <UserOutlined />}
                  className="p-[3px] bg-primary rounded-[20px] object-cover shadow-md"
                />
              </div>
            </div>

            {/* Profile Info Section - Right */}
            <div className="profile-info-section flex-1">
              <h6 className="text-white-700 font-semibold text-lg mb-4">
                Profile Details
              </h6>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="profile-field">
                  <label className="profile-label text-white font-medium text-sm mb-2 block">
                    First Name
                  </label>
                  <div className="profile-value bg-gray-50 p-3 rounded-md border text-gray-800 font-medium">
                    {currentUser?.firstName ||
                      currentUser?.name?.split(" ")[0] ||
                      "N/A"}
                  </div>
                </div>

                <div className="profile-field">
                  <label className="profile-label text-white font-medium text-sm mb-2 block">
                    Last Name
                  </label>
                  <div className="profile-value bg-gray-50 p-3 rounded-md border text-gray-800 font-medium">
                    {currentUser?.lastName ||
                      currentUser?.name?.split(" ")[1] ||
                      "N/A"}
                  </div>
                </div>

                <div className="profile-field">
                  <label className="profile-label text-white font-medium text-sm mb-2 block">
                    Email
                  </label>
                  <div className="profile-value bg-gray-50 p-3 rounded-md border text-gray-800 font-medium">
                    {currentUser?.email || "N/A"}
                  </div>
                </div>

                <div className="profile-field">
                  <label className="profile-label text-white font-medium text-sm mb-2 block">
                    Mobile Number
                  </label>
                  <div className="profile-value bg-gray-50 p-3 rounded-md border text-gray-800 font-medium">
                    {formatProfileMobileNumber(currentUser?.mobileNumber) ||
                      "N/A"}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-12">
            <div className="btn-groups-Forms text-end">
              <Button
                buttonText="Back"
                padding="py-[20px] px-[25px] 2xl:py-[15px] 2xl:px-[25px]"
                text="text-[15px]"
                handleIsModelOpen={handleBack}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
